// extracted by mini-css-extract-plugin
export default {"cls1":"X9wSJxX2fdFpW7lrZwrg","cls2":"MCoflJmixMgo5jqn1XHJ X9wSJxX2fdFpW7lrZwrg"};